import { z } from "zod";

import { FeatureFlagKind } from "./enums";

export const featureFlagKindSchema = z.nativeEnum(FeatureFlagKind);

export const featureFlagDefinitionSchema = z.object({
  key: z.string(),
  name: z.string(),
  description: z.string(),
  kind: featureFlagKindSchema,
  defaultEnabled: z.boolean(),
});

/** An admin's per-organization override of one flag. Absent means "inherit the default". */
export const featureFlagOverrideSchema = z.object({
  enabled: z.boolean(),
  note: z.string().nullable(),
  updatedById: z.string().nullable(),
  updatedByName: z.string().nullable(),
  updatedAt: z.string(),
});
export type FeatureFlagOverride = z.infer<typeof featureFlagOverrideSchema>;

/** One flag as the admin sees it: the definition, the resolved value, and the override behind it. */
export const adminFeatureFlagSchema = featureFlagDefinitionSchema.extend({
  effective: z.boolean(),
  override: featureFlagOverrideSchema.nullable(),
});
export type AdminFeatureFlag = z.infer<typeof adminFeatureFlagSchema>;

export const adminOrganizationFeatureFlagsSchema = z.object({
  flags: z.array(adminFeatureFlagSchema),
});
export type AdminOrganizationFeatureFlags = z.infer<typeof adminOrganizationFeatureFlagsSchema>;

/** What an app receives for its own organization: key to resolved value. */
export const organizationFeatureFlagsSchema = z.object({
  flags: z.record(z.string(), z.boolean()),
});
export type OrganizationFeatureFlags = z.infer<typeof organizationFeatureFlagsSchema>;

export const setFeatureFlagSchema = z.object({
  enabled: z.boolean(),
  note: z.string().trim().max(280).optional(),
});
export type SetFeatureFlagInput = z.infer<typeof setFeatureFlagSchema>;
